import cx from 'classnames'
import React from 'react'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'

import { Arrow } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './filter-radio-parent.module.css'

const {
  font: { size: fontSize },
} = tokens.customProperties

interface FilterRadioParentProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  input: WrappedFieldInputProps
  meta?: WrappedFieldMetaProps
  hideArrow?: boolean
}

const FilterRadioParent: React.FC<FilterRadioParentProps> = ({ label, input, hideArrow = false }) => {
  return (
    <label
      className={cx(styles.radioFilterLabel, {
        [styles.active]: input.checked,
      })}
    >
      <input type="radio" className={styles.radioFilterInput} {...input} />
      {label}
      {!hideArrow && (
        <div className={styles.radioFilterLabelSpacer}>
          <SVG children={Arrow} size={fontSize.s} />
        </div>
      )}
    </label>
  )
}

export default FilterRadioParent
